import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Grid, Row, Image } from 'react-bootstrap';

class StatusIndicators extends Component {

    constructor(props) {
        super(props);

        this.urlPrefix = `${process.env.PUBLIC_URL}/api/ClimaControl/Status/`;
        this.state = {
            urlCO2: this.urlPrefix + "co2",
            urlTemperature: this.urlPrefix + "temperature",
            urlHumidity: this.urlPrefix + "humidity",
            urlDustDensity: this.urlPrefix + "dust",
        };
        this.interval = null;
        console.log("constructor");
    }

    componentWillMount() {
        this.setState({ state: this.state });
        this.interval = setInterval(() => {
            console.log("Status indicators updating ... - " + this.state.urlCO2);
            //this.forceUpdate();

            this.setState({ urlTemperature: this.urlPrefix + "temperature?random=" + Math.random() });
            this.setState({ urlHumidity: this.urlPrefix + "humidity?random=" + Math.random() });
            this.setState({ urlDustDensity: this.urlPrefix + "dust?random=" + Math.random() });
            this.setState({ urlCO2: this.urlPrefix + "co2?random=" + Math.random() });

        }, 5000);
    }

    componentWillUnmount() {
        if (this.interval !== undefined && this.interval !== null)
            clearInterval(this.interval);
    }

    shouldComponentUpdate() {
        return true;
    }

    render() {
        return (
            <Row>
                <Col xs={3}>
                    <img src={this.state.urlTemperature} width="50" height="50" />
                    <div>Temperature</div>
                </Col>
                <Col xs={3}>
                    <img src={this.state.urlHumidity} width="50" height="50" />
                    <div>Humidity</div>
                </Col>
                <Col xs={3}>
                    <img src={this.state.urlDustDensity} width="50" height="50" />
                    <div>Dust Density</div>
                </Col>
                <Col xs={3}>
                    <Image src={this.state.urlCO2} width="50" height="50" />
                    <div>CO2</div>
                </Col>
            </Row>
        );
    }
}

export default connect(
    state => state.counter
)(StatusIndicators);



// WEBPACK FOOTER //
// ./src/components/StatusIndicators.js